(function () {
  'use strict';

  if (window.CurrencySwapInit) return;
  window.CurrencySwapInit = true;

  const EXCHANGE_RATE = 1.95583;
  const TEXT_TAGS = ['span', 'b', 'p', 'strong', 'div', 'li', 'a', 'option', 'del', 'sup', 'sub'];
  const BLOCK_TAGS = ['div', 'dd', 'td', 'ul', 'span', 'p', 's', 'del', 'sup', 'sub'];

  const nbsp = '&nbsp;';

  const BGN_PATTERNS = [
    { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9.]+,[0-9]{2}))/i, idx: 3, dec: ',', thou: '.', cur: 'BGN' },
    { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9,]+\.[0-9]{2}))/i, idx: 3, dec: '.', thou: ',', cur: 'BGN' },
    { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9][0-9.]*))/i, idx: 3, thou: '.', cur: 'BGN' },
    { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9][0-9,]*))/i, idx: 3, thou: ',', cur: 'BGN' },
    { regex: /(([-+]?[0-9.]+,[0-9]{2})\s*(лв\.?|лева|лев|BGN|bgn))/i, idx: 2, dec: ',', thou: '.', cur: 'BGN' },
    { regex: /(([-+]?[0-9,]+\.[0-9]{2})\s*(лв\.?|лева|лев|BGN|bgn))/i, idx: 2, dec: '.', thou: ',', cur: 'BGN' },
    { regex: /(([-+]?[0-9][0-9.]*)\s*(лв\.?|лева|лев|BGN|bgn))/i, idx: 2, thou: '.', cur: 'BGN' },
    { regex: /(([-+]?[0-9][0-9,]*)\s*(лв\.?|лева|лев|BGN|bgn))/i, idx: 2, thou: ',', cur: 'BGN' },
  ];

  const EUR_PATTERNS = [
    { regex: /((€|EUR|eur|евро)\s*([0-9.]+,[0-9]{2}))/i, idx: 3, dec: ',', thou: '.', cur: 'EUR' },
    { regex: /((€|EUR|eur|евро)\s*([0-9,]+\.[0-9]{2}))/i, idx: 3, dec: '.', thou: ',', cur: 'EUR' },
    { regex: /((€|EUR|eur|евро)\s*([0-9][0-9.]*))/i, idx: 3, thou: '.', cur: 'EUR' },
    { regex: /((€|EUR|eur|евро)\s*([0-9][0-9,]*))/i, idx: 3, thou: ',', cur: 'EUR' },
    { regex: /(([-+]?[0-9.]+,[0-9]{2})\s*(€|EUR|eur|евро))/i, idx: 2, dec: ',', thou: '.', cur: 'EUR' },
    { regex: /(([-+]?[0-9,]+\.[0-9]{2})\s*(€|EUR|eur|евро))/i, idx: 2, dec: '.', thou: ',', cur: 'EUR' },
    { regex: /(([-+]?[0-9][0-9.]*)\s*(€|EUR|eur|евро))/i, idx: 2, thou: '.', cur: 'EUR' },
    { regex: /(([-+]?[0-9][0-9,]*)\s*(€|EUR|eur|евро))/i, idx: 2, thou: ',', cur: 'EUR' },
  ];

  const CURRENCY_PATTERNS = [...BGN_PATTERNS, ...EUR_PATTERNS];

  function escapeSeparator(s) {
    return s === '.' ? '\\.' : s;
  }

  function formatNum(value, cur, superscript = false) {
    const formatted = Number(value).toFixed(2);
    const [whole, decimal] = formatted.split('.');
    const spacedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return superscript ? `${spacedWhole}<span>,</span><sup>${decimal}</sup>` : `${spacedWhole}<span>,</span><sup>${decimal}</sup>`;
  }

  function convertToEur(value) {
    return (value / EXCHANGE_RATE).toFixed(2);
  }

  function convertToBgn(value) {
    return (value * EXCHANGE_RATE).toFixed(2);
  }

  function translateText(text, node) {
    if (text.includes(' | ')) return null;
    let result = '';
    let remainder = text;

    do {
      let matched = false;

      for (const pattern of CURRENCY_PATTERNS) {
        const match = remainder.match(pattern.regex);
        if (match) {
          let raw = match[pattern.idx];
          if (pattern.thou) raw = raw.replace(new RegExp(escapeSeparator(pattern.thou), 'g'), '');
          if (pattern.dec === ',') raw = raw.replace(',', '.');
          const value = parseFloat(raw);

          let bgn, eur;
          if (pattern.cur === 'BGN') {
            bgn = value;
            eur = convertToEur(value);
          } else {
            eur = value;
            bgn = convertToBgn(value);
          }

          const bgnFormatted = `<span class="bgn" data-converted="true">${formatNum(bgn, 'BGN', true)}${nbsp}лв</span>`;
          const eurFormatted = `<span class="eur" data-converted="true">${formatNum(eur, 'EUR', true)}${nbsp}€</span>`;

          const full = `${eurFormatted} <br> ${bgnFormatted}`;
          const fullRCard = `${eurFormatted} | ${bgnFormatted}`;
          const fullBGN = `${eurFormatted}`;
          // console.log(match)
          if (node.parentNode.classList?.contains('price--compare')) {
            remainder = remainder.replace(match[0], fullBGN);
          } else if(node.parentNode.classList?.contains('ralica-card-cena')) {
            remainder = remainder.replace(match[0], fullRCard);
          } else {
            remainder = remainder.replace(match[0], full);
          }
          matched = true;
          break;
        }
      }

      if (!matched) {
        result += remainder;
        break;
      }

    } while (remainder.length > 0);

    return result;
  }

  function modifyTextNode(node) {
    if (
      node.parentNode &&
      (node.parentNode.classList?.contains('bgn') ||
       node.parentNode.classList?.contains('eur') ||
       node.parentNode.dataset?.converted === 'true')
    ) return;

    const updated = translateText(node.textContent, node);
    if (updated && updated !== node.textContent) {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = updated;
      wrapper.dataset.converted = 'true';
      node.parentNode.replaceChild(wrapper, node);
    }
  }

  function getAllElements(tags) {
    return tags.flatMap(t => Array.from(document.getElementsByTagName(t)));
  }

  function scanAndUpdate() {
    const elements = getAllElements(TEXT_TAGS).concat(getAllElements(BLOCK_TAGS));
    for (const el of elements) {
      if (!el.childNodes) continue;
      for (const child of el.childNodes) {
        if (child.nodeType === Node.TEXT_NODE) {
          modifyTextNode(child);
        }
      }
    }
  }

  function startConversion() {
    setTimeout(() => {
      scanAndUpdate();              // 1st run (after 100ms)
      setTimeout(scanAndUpdate, 3000); // 2nd run (after 3s)

      if (window.MutationObserver) {
        const observer = new MutationObserver(scanAndUpdate);
        observer.observe(document.body, { childList: true, subtree: true });
        window.CurrencySwapController = {
          refresh: scanAndUpdate,
          disconnect: () => {
            observer.disconnect();
            window.CurrencySwapInit = false;
          },
          version: 'CurrencySwap v1.0'
        };
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startConversion, { once: true });
  } else {
    startConversion();
  }
})();
